import { complianceCheckUrl } from './getReachableUrl'

export const COMPLIANCE_URL_ERROR_MESSAGE = 'The URL you entered could not be reached.'

type IComplianceUrlField = {
  value: string
  setValue: (url: string) => void
  setError: (message: string) => void
}

type ICheckComplianceUrlsParams = {
  privacyPolicyUrl: IComplianceUrlField
  termsUrl: IComplianceUrlField
}

export const checkComplianceUrls = async (params: ICheckComplianceUrlsParams) => {
  const privacyUrl = params.privacyPolicyUrl.value.trim()
  const termsUrl = params.termsUrl.value.trim()

  if (!privacyUrl && !termsUrl) {
    return true
  }

  const [privacyResult, termsResult] = await Promise.all([
    privacyUrl ? complianceCheckUrl(privacyUrl) : Promise.resolve(null),
    termsUrl ? complianceCheckUrl(termsUrl) : Promise.resolve(null),
  ])

  let isValid = true

  if (privacyUrl) {
    if (privacyResult) {
      params.privacyPolicyUrl.setValue(privacyResult)
    } else {
      params.privacyPolicyUrl.setError(COMPLIANCE_URL_ERROR_MESSAGE)
      isValid = false
    }
  }

  if (termsUrl) {
    if (termsResult) {
      params.termsUrl.setValue(termsResult)
    } else {
      params.termsUrl.setError(COMPLIANCE_URL_ERROR_MESSAGE)
      isValid = false
    }
  }

  return isValid
}
